import PropTypes from 'prop-types';
import React, { Component } from 'react';
import injectSheet from 'react-jss';

import AndOrToggle from '~/components/Shared/AndOrToggle/AndOrToggle';
import { Button } from '~/eds/src/components/Button/Button';
import { injectIntl } from 'react-intl';

import { MODAL_ADD_FILTER } from '../../../types/modal.types';
import EcFilterBooleanTextSearch from '../EcFilterBooleanTextSearch/EcFilterBooleanTextSearch';
import EcFilterField from '../EcFilterField/EcFilterField';
import EcFilterFolderField from '../EcFilterFolderField/EcFilterFolderField';
import EcFilterProvision from '../EcFilterProvision/EcFilterProvision';
import EcFilterTextSearch from '../EcFilterTextSearch/EcFilterTextSearch';
import EcModal from '../EcModal/EcModal';
import styles from './EcFiltersSection.styles';

class EcFiltersSection extends Component {
  constructor(props) {
    super(props);

    this.handleOnRemoveClick = this.handleOnRemoveClick.bind(this);
    this.removeSubSection = this.removeSubSection.bind(this);
    this.handleOnAddSectionClick = this.handleOnAddSectionClick.bind(this);
    this.handleOnAddFilterClick = this.handleOnAddFilterClick.bind(this);
    this.handleAddFilter = this.handleAddFilter.bind(this);
    this.handleAddProvision = this.handleAddProvision.bind(this);
    this.handleAddTextSearch = this.handleAddTextSearch.bind(this);
    this.handleAddBooleanTextSearch =
      this.handleAddBooleanTextSearch.bind(this);
    this.handleHideModal = this.handleHideModal.bind(this);

    this.state = { modal: null };
  }

  componentDidMount() {
    if (this.props.openEmptySection) this.handleOnAddSectionClick();
  }

  handleOnAddSectionClick() {
    this.addNewEntity('section');
  }

  handleOnAddFilterClick(replacingFilterIndex) {
    this.setState({ modal: { type: MODAL_ADD_FILTER, replacingFilterIndex } });
  }

  handleAddFilter(filter, replaceFilterIndex) {
    this.addNewEntity('field', filter, replaceFilterIndex);
  }

  handleAddProvision(provision, replaceFilterIndex) {
    this.addNewEntity('provision', provision, replaceFilterIndex);
  }

  handleAddTextSearch(textSearch, replaceFilterIndex) {
    this.addNewEntity('text_search', textSearch, replaceFilterIndex);
  }

  handleAddBooleanTextSearch(boolTextSearch, replaceFilterIndex) {
    this.addNewEntity('bool_text_search', boolTextSearch, replaceFilterIndex);
  }

  addNewEntity(entityType, entity, replaceFilterIndex) {
    const { filters, onChange, sectionIndex } = this.props;

    const newEntity =
      entityType === 'section'
        ? { entity: 'section', section: [] }
        : { ...entity, entity: entityType };
    const newFilters = [...filters];

    if (Number.isInteger(replaceFilterIndex)) {
      newFilters[replaceFilterIndex] = newEntity;
    } else {
      if (filters.length) {
        const operator = { entity: 'operator', operator: 'and' };
        newFilters.push(operator);
      }

      newFilters.push(newEntity);
    }

    onChange(newFilters, sectionIndex);
  }

  handleHideModal() {
    this.setState({ modal: null });
  }

  handleFilterChange(filterIndex, value) {
    const { filters, onChange, sectionIndex } = this.props;

    const newFilters = [...filters];
    newFilters[filterIndex] = value;

    onChange(newFilters, sectionIndex);
  }

  handleSubSectionFiltersChange(subSectionId, subSectionFilters) {
    const { filters, onChange, sectionIndex } = this.props;

    filters[subSectionId] = { entity: 'section', section: subSectionFilters };
    onChange(filters, sectionIndex);
  }

  removeSubItem(index) {
    const { filters, onChange, sectionIndex } = this.props;

    let newFilters = [...filters];
    if (index === filters.length - 1) {
      newFilters.splice(index - 1, 2);
    } else {
      newFilters.splice(index, 2);
    }

    onChange(newFilters, sectionIndex);
  }

  handleOnRemoveClick(index) {
    this.removeSubItem(index);
  }

  removeSubSection(sectionIndex) {
    this.removeSubItem(sectionIndex);
  }

  generateUIFilters(filters) {
    const {
      classes,
      enablePinning,
      enableTextSearch,
      filterOptions,
      provisionOptions,
      handleFilterOptionsChange,
    } = this.props;

    return filters.map((filter, filterIndex) => {
      let filterItem;

      if (filter.entity === 'section') {
        return (
          <EcFiltersSectionStyled
            enablePinning={enablePinning}
            enableTextSearch={enableTextSearch}
            filters={filter.section}
            filterOptions={filterOptions}
            provisionOptions={provisionOptions}
            onChange={(subSectionFilters, subSectionId) =>
              this.handleSubSectionFiltersChange(
                subSectionId,
                subSectionFilters,
              )
            }
            handleOnRemoveSectionClick={this.removeSubSection}
            handleFilterOptionsChange={handleFilterOptionsChange}
            sectionIndex={filterIndex}
            key={`section-${filterIndex}`}
          />
        );
      }

      if (filter.entity === 'operator') {
        return (
          <div
            className={classes.operatorWrapper}
            key={`operator-${filterIndex}`}
          >
            <AndOrToggle
              value={filter.operator}
              onChange={(operator) => {
                this.handleFilterChange(filterIndex, {
                  entity: 'operator',
                  operator,
                });
              }}
            />
          </div>
        );
      }

      if (filter.entity === 'field') {
        filterItem = (
          <EcFilterField
            {...filter}
            onChange={(filterProperty) =>
              this.handleFilterChange(filterIndex, {
                ...filter,
                ...filterProperty,
              })
            }
            onRemoveClick={() => this.handleOnRemoveClick(filterIndex)}
            onFilterNameClick={() => this.handleOnAddFilterClick(filterIndex)}
          />
        );
      }

      if (filter.entity === 'provision') {
        filterItem = (
          <EcFilterProvision
            {...filter}
            onChange={(filterProperty) =>
              this.handleFilterChange(filterIndex, {
                ...filter,
                ...filterProperty,
              })
            }
            onRemoveClick={() => this.handleOnRemoveClick(filterIndex)}
            onFilterNameClick={() => this.handleOnAddFilterClick(filterIndex)}
          />
        );
      }

      if (filter.entity === 'text_search') {
        filterItem = (
          <EcFilterTextSearch
            {...filter}
            onChange={(filterProperty) =>
              this.handleFilterChange(filterIndex, {
                ...filter,
                ...filterProperty,
              })
            }
            onRemoveClick={() => this.handleOnRemoveClick(filterIndex)}
            onFilterNameClick={() => this.handleOnAddFilterClick(filterIndex)}
          />
        );
      }

      if (filter.entity === 'bool_text_search') {
        filterItem = (
          <EcFilterBooleanTextSearch
            {...filter}
            onChange={(filterProperty) =>
              this.handleFilterChange(filterIndex, {
                ...filter,
                ...filterProperty,
              })
            }
            onRemoveClick={() => this.handleOnRemoveClick(filterIndex)}
          />
        );
      }

      if (filter.entity === 'folder') {
        filterItem = (
          <EcFilterFolderField
            {...filter}
            onChange={(filterProperty) =>
              this.handleFilterChange(filterIndex, {
                ...filter,
                ...filterProperty,
              })
            }
            onRemoveClick={() => this.handleOnRemoveClick(filterIndex)}
            onFilterNameClick={() => this.handleOnAddFilterClick(filterIndex)}
          />
        );
      }

      return (
        <div
          className={classes.filterItemWrapper}
          key={`${filter.id}-${filterIndex}`}
        >
          {filterItem}
        </div>
      );
    });
  }

  renderAddFilterModal() {
    const {
      enablePinning,
      enableTextSearch,
      filterOptions,
      provisionOptions,
      handleFilterOptionsChange,
    } = this.props;
    const { modal } = this.state;

    return (
      <EcModal
        modalType={MODAL_ADD_FILTER}
        hideModal={this.handleHideModal}
        width="720px"
        enablePinning={enablePinning}
        enableTextSearch={enableTextSearch}
        filterOptions={filterOptions}
        provisionOptions={provisionOptions}
        handleFilterOptionsChange={handleFilterOptionsChange}
        handleAddFilter={this.handleAddFilter}
        handleAddProvision={this.handleAddProvision}
        handleAddTextSearch={this.handleAddTextSearch}
        handleAddBooleanTextSearch={this.handleAddBooleanTextSearch}
        replacingFilterIndex={modal.replacingFilterIndex}
      />
    );
  }

  render() {
    const {
      classes,
      filters,
      rootSection,
      handleOnRemoveSectionClick,
      sectionIndex,
      hideAddFilterAction,
      intl,
    } = this.props;
    const { modal } = this.state;

    const emptySectionMessage = rootSection
      ? intl.formatMessage({
          id: 'EcFiltersSection.noFiltersAdded',
          defaultMessage: "You haven't added any filters.",
          description:
            'Message when no filters have been added to root section',
        })
      : intl.formatMessage({
          id: 'EcFiltersSection.sectionEmpty',
          defaultMessage: 'This section does not contain any filters.',
          description: 'Message when a section contains no filters',
        });

    return (
      <div className={classes.filterSectionWrapper}>
        {this.generateUIFilters(filters)}
        {!filters.length && (
          <div className={classes.emptySectionMessage}>
            {emptySectionMessage}
          </div>
        )}
        <div className={classes.sectionActions}>
          {!hideAddFilterAction && (
            <Button
              onClick={() => this.handleOnAddFilterClick(null)}
              icon="plus"
              iconPosition="left"
              text={intl.formatMessage({
                id: 'EcFiltersSection.addFilter',
                defaultMessage: 'Add a Filter',
                description: 'Button text to add a new filter',
              })}
              variant="action"
              id="analyzer-add-a-filter-link"
            />
          )}
          <Button
            onClick={this.handleOnAddSectionClick}
            icon="plus"
            iconPosition="left"
            text={intl.formatMessage({
              id: 'EcFiltersSection.addSection',
              defaultMessage: 'Add a Section',
              description: 'Button text to add a new section',
            })}
            variant="action"
            id="analyzer-add-a-section-link"
          />

          {!rootSection && (
            <>
              <span className={classes.actionSeparator} />
              <Button
                onClick={() => handleOnRemoveSectionClick(sectionIndex)}
                icon="x"
                iconPosition="left"
                text={intl.formatMessage({
                  id: 'EcFiltersSection.removeSection',
                  defaultMessage: 'Remove Section',
                  description: 'Button text to remove a section',
                })}
                variant="action"
                id="analyzer-remove-a-section-link"
              />
            </>
          )}
        </div>
        {modal &&
          modal.type === MODAL_ADD_FILTER &&
          this.renderAddFilterModal()}
      </div>
    );
  }
}

EcFiltersSection.propTypes = {
  enableTextSearch: PropTypes.bool,
  enablePinning: PropTypes.bool,
  filters: PropTypes.array.isRequired,
  filterOptions: PropTypes.array.isRequired,
  provisionOptions: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
  handleFilterOptionsChange: PropTypes.func,
  rootSection: PropTypes.bool,
  hideAddFilterAction: PropTypes.bool,
};

EcFiltersSection.defaultProps = {
  enableTextSearch: true,
  enablePinning: true,
};

const EcFiltersSectionStyled = injectSheet(styles)(
  injectIntl(EcFiltersSection),
);

export default EcFiltersSectionStyled;
